import { render, staticRenderFns } from "./SwapSuggestionItem.vue?vue&type=template&id=49eff440&scoped=true&"
import script from "./SwapSuggestionItem.vue?vue&type=script&lang=js&"
export * from "./SwapSuggestionItem.vue?vue&type=script&lang=js&"
import style0 from "./SwapSuggestionItem.vue?vue&type=style&index=0&id=49eff440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eff440",
  null
  
)

export default component.exports